import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_flexcol _gap-3 _tac _px-6 _pt-9 _pb-5 _pos-r" }
const _hoisted_2 = { class: "gfu-bt gfu-bt--b1 _fs-i _px-6 _lh-big" }
const _hoisted_3 = { class: "" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "gfu-quote _tc--light" }, null, -1 /* CACHED */)),
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createElementVNode("div", _hoisted_2, _toDisplayString($props.quote), 1 /* TEXT */)
    ]),
    _renderSlot(_ctx.$slots, "author", {}, () => [
      _createElementVNode("div", _hoisted_3, _toDisplayString($props.author), 1 /* TEXT */)
    ])
  ]))
}